<template>
  <fin-auto-load-more-news-list/>
</template>

<script>
import FinAutoLoadMoreNewsList from "@/components/common/news/AutoLoadMoreNewsList"

export default {
  name: 'fin-news-overview',
  components: {FinAutoLoadMoreNewsList}
}
</script>

<style scoped>
</style>
